import React, { PureComponent } from 'react';

class PeriodoActual extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {

        const { motivoAjusteDataFiltrado } = this.props.ingresoAjuste;
        let lblPeriodo;

        if(motivoAjusteDataFiltrado && motivoAjusteDataFiltrado.ImpactaPeriodoActual)
            lblPeriodo = "Aplica a Período Actual";

        if(motivoAjusteDataFiltrado && !motivoAjusteDataFiltrado.ImpactaPeriodoActual)
            lblPeriodo = "Aplica sobre Saldo Anterior";

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Aplica Período Actual / Saldo Anterior</label>
                    <label>{lblPeriodo}</label>
                </div>
            </div>
        )
    }
}

export default PeriodoActual;